//export const apiSrcUrl = 'http://localhost:3000/api'

export const apiSrcUrl = `${process.env.REACT_APP_BASE_URL}`